export default "__VITE_ASSET__DRFR2TY$__"